import {
  RESET_CREATE_DOCUMENT_DATA,
  SET_ADDITIONAL_DETAIL_DATA,
  SET_ADVANCE_PAYMENT,
  SET_BANK_DETAILS,
  SET_COMMENT_INPUT_DATA,
  SET_BUYER_DATA,
  SET_DOCUMENT_ADDITIONAL_CHARGES,
  SET_DOCUMENT_ATTACHMENTS_DATA,
  SET_DOCUMENT_FORM_DATA,
  SET_DOCUMENT_ITEM_GRID_DATA,
  SET_DOCUMENT_TO,
  SET_DOCUMENT_TYPE,
  SET_DOCUMENTS_SIGNATURE_DATA,
  SET_DOCUMENTS_TERMS_AND_CONDITION_DATA,
  SET_INDIVIDUAL_DATA,
  SET_LOGISTIC_DETAIL_DATA,
  SET_SUPPLIER_DATA,
  SET_BUYER_SUPPLIER_KYC_DETAIL,
  SET_BATCH_DATA,
} from "../../types/UI/createDocument";

const initialState = {
  documentType: "",
  documentTo: "",
  buyerDetails: [],
  supplierDetails: [],
  itemData: [],
  formData: [],
  additionalCharges: [],
  logisticDetails: [],
  additionalDetails: "",
  commentInput: "",
  attachments: [],
  signature: [],
  termsAndCondition: null,
  bankDetails: [],
  advancePayment: 0,
  individualData: {
    buyerName: "",
    buyerEmail: "",
    contactNumber: "",
    addressLineOne: "",
    pincode: "",
    city: "",
    state: "",
    country: "",
  },
  batches: [],
  isMultyCurrency: false,
  currencyCode: "",
};

export interface IAction {
  type: string;
  payload?: any;
}

const createDocumentUIReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case SET_DOCUMENT_TYPE:
      return {
        ...state,
        documentType: action.payload,
      };

    case SET_DOCUMENT_TO:
      return {
        ...state,
        documentTo: action.payload,
      };

    case SET_BUYER_DATA:
      return {
        ...state,
        buyerDetails: action.payload,
      };

    case SET_SUPPLIER_DATA:
      return {
        ...state,
        supplierDetails: action.payload,
      };

    case SET_DOCUMENT_ITEM_GRID_DATA:
      return {
        ...state,
        itemData: action.payload,
      };

    case SET_DOCUMENT_ADDITIONAL_CHARGES:
      console.log(action.payload);
      return {
        ...state,
        additionalCharges: action.payload,
      };

    case SET_DOCUMENT_FORM_DATA:
      return {
        ...state,
        formData: action.payload,
      };

    case SET_BATCH_DATA:
      return {
        ...state,
        batches: action.payload,
      };

    case SET_LOGISTIC_DETAIL_DATA:
      return {
        ...state,
        logisticDetails: action.payload,
      };

    case SET_ADDITIONAL_DETAIL_DATA:
      return {
        ...state,
        additionalDetails: action.payload,
      };

    case SET_COMMENT_INPUT_DATA:
      return {
        ...state,
        commentInput: action.payload,
      };

    case SET_DOCUMENT_ATTACHMENTS_DATA:
      return {
        ...state,
        attachments: action.payload,
      };

    case SET_DOCUMENTS_SIGNATURE_DATA:
      return {
        ...state,
        signature: action.payload,
      };

    case SET_DOCUMENTS_TERMS_AND_CONDITION_DATA:
      return {
        ...state,
        termsAndCondition: action.payload,
      };

    case SET_BANK_DETAILS:
      return {
        ...state,
        bankDetails: action.payload,
      };

    case SET_ADVANCE_PAYMENT:
      return {
        ...state,
        advancePayment: action.payload,
      };

    case SET_INDIVIDUAL_DATA:
      return {
        ...state,
        individualData: action.payload,
      };
    case SET_BUYER_SUPPLIER_KYC_DETAIL:
      return {
        ...state,
        buyerSupplierKYCDetails: action.payload,
      };
    case RESET_CREATE_DOCUMENT_DATA:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default createDocumentUIReducer;
